import {
  createTaxGroup as publicCreateTaxGroup,
  getTaxGroup as publicGetTaxGroup,
  updateTaxGroup as publicUpdateTaxGroup,
  deleteTaxGroup as publicDeleteTaxGroup,
  queryTaxGroups as publicQueryTaxGroups,
  typedQueryTaxGroups as publicTypedQueryTaxGroups,
  listDefaultTaxGroups as publicListDefaultTaxGroups,
  listDefaultTaxGroupsByAppIds as publicListDefaultTaxGroupsByAppIds,
} from './billing-v1-tax-group-tax-groups.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  TaxGroupQuery,
  TaxGroupsQueryBuilder,
  typedQueryTaxGroups as universalTypedQueryTaxGroups,
} from './billing-v1-tax-group-tax-groups.universal.js';
import { onTaxGroupCreated as publicOnTaxGroupCreated } from './billing-v1-tax-group-tax-groups.public.js';
import { onTaxGroupDeleted as publicOnTaxGroupDeleted } from './billing-v1-tax-group-tax-groups.public.js';
import { onTaxGroupUpdated as publicOnTaxGroupUpdated } from './billing-v1-tax-group-tax-groups.public.js';

function customQueryTaxGroups(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryTaxGroups(httpClient)(),
    typedQueryFunction: (query: TaxGroupQuery) =>
      publicTypedQueryTaxGroups(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): TaxGroupsQueryBuilder;
  function overloadedQuery(
    query: TaxGroupQuery
  ): ReturnType<typeof universalTypedQueryTaxGroups>;
  function overloadedQuery(query?: TaxGroupQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createTaxGroup: MaybeContext<
  BuildRESTFunction<typeof publicCreateTaxGroup> & typeof publicCreateTaxGroup
> = /*#__PURE__*/ createRESTModule(publicCreateTaxGroup);
export const getTaxGroup: MaybeContext<
  BuildRESTFunction<typeof publicGetTaxGroup> & typeof publicGetTaxGroup
> = /*#__PURE__*/ createRESTModule(publicGetTaxGroup);
export const updateTaxGroup: MaybeContext<
  BuildRESTFunction<typeof publicUpdateTaxGroup> & typeof publicUpdateTaxGroup
> = /*#__PURE__*/ createRESTModule(publicUpdateTaxGroup);
export const deleteTaxGroup: MaybeContext<
  BuildRESTFunction<typeof publicDeleteTaxGroup> & typeof publicDeleteTaxGroup
> = /*#__PURE__*/ createRESTModule(publicDeleteTaxGroup);
export const listDefaultTaxGroups: MaybeContext<
  BuildRESTFunction<typeof publicListDefaultTaxGroups> &
    typeof publicListDefaultTaxGroups
> = /*#__PURE__*/ createRESTModule(publicListDefaultTaxGroups);
export const listDefaultTaxGroupsByAppIds: MaybeContext<
  BuildRESTFunction<typeof publicListDefaultTaxGroupsByAppIds> &
    typeof publicListDefaultTaxGroupsByAppIds
> = /*#__PURE__*/ createRESTModule(publicListDefaultTaxGroupsByAppIds);
export const queryTaxGroups: MaybeContext<
  BuildRESTFunction<typeof customQueryTaxGroups> & typeof customQueryTaxGroups
> = /*#__PURE__*/ createRESTModule(customQueryTaxGroups);
/**
 * Triggered when a tax group is created.
 */
export const onTaxGroupCreated: BuildEventDefinition<
  typeof publicOnTaxGroupCreated
> &
  typeof publicOnTaxGroupCreated = createEventModule(publicOnTaxGroupCreated);
/**
 * Triggered when a tax group is deleted.
 */
export const onTaxGroupDeleted: BuildEventDefinition<
  typeof publicOnTaxGroupDeleted
> &
  typeof publicOnTaxGroupDeleted = createEventModule(publicOnTaxGroupDeleted);
/**
 * Triggered when a tax group is updated.
 */
export const onTaxGroupUpdated: BuildEventDefinition<
  typeof publicOnTaxGroupUpdated
> &
  typeof publicOnTaxGroupUpdated = createEventModule(publicOnTaxGroupUpdated);

export {
  SortOrder,
  WebhookIdentityType,
} from './billing-v1-tax-group-tax-groups.universal.js';
export {
  TaxGroup,
  CreateTaxGroupRequest,
  CreateTaxGroupResponse,
  GetTaxGroupRequest,
  GetTaxGroupResponse,
  UpdateTaxGroupRequest,
  UpdateTaxGroupResponse,
  DeleteTaxGroupRequest,
  DeleteTaxGroupResponse,
  QueryTaxGroupsRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Sorting,
  Paging,
  CursorPaging,
  QueryTaxGroupsResponse,
  CursorPagingMetadata,
  Cursors,
  ListDefaultTaxGroupsRequest,
  ListDefaultTaxGroupsResponse,
  ListDefaultTaxGroupsByAppIdsRequest,
  ListDefaultTaxGroupsByAppIdsResponse,
  ListDefaultTaxGroupsByAppIdsResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  TaxGroupCreatedEnvelope,
  TaxGroupDeletedEnvelope,
  TaxGroupUpdatedEnvelope,
  UpdateTaxGroup,
  TaxGroupsQueryResult,
  TaxGroupsQueryBuilder,
  TaxGroupQuerySpec,
} from './billing-v1-tax-group-tax-groups.universal.js';
export { utils } from './billing-v1-tax-group-tax-groups.universal.js';
export {
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  UpdateTaxGroupApplicationErrors,
  CommonQueryWithEntityContext,
  TaxGroupQuery,
} from './billing-v1-tax-group-tax-groups.universal.js';
